import React, { useState } from 'react';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { baseurladdress } from "../baseurl";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";

function Editdepartment(props) {
    const { dept_id } = useParams();
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const Swal = require('sweetalert2')

    const navigate = useNavigate();

    const [dept_name, setdept_name] = useState("");
    const [dept_code, setdept_code] = useState("");
    const [dept_headname, setdept_headname] = useState("");
    const [dept_description, setdept_description] = useState("");
    const [dept_status, setdept_status] = useState("");
    const [x, setX] = useState("");
    const [xy, setXY] = useState("");

    //edit department
    useEffect(() => {
        axios
            .get(baseurladdress + `editdepartment/` + dept_id, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                const data = res.data.response;
                setdept_name(data[0].dept_name);
                setdept_code(data[0].dept_code);
                setdept_headname(data[0].dept_headname);
                setdept_status(data[0].dept_status);
                setdept_description(data[0].dept_description);
                setXY(data[0].dept_status);
                const check = (data[0].dept_status == "1") ? true : false;
                setX(check);
            });
    }, [dept_id]);

    //update department
     const handleSubmit = (event) => {
            event.preventDefault();
            var data = {
                dept_name: dept_name,
                dept_code: dept_code,
                dept_headname: dept_headname,
                dept_status: dept_status,
                dept_description: dept_description,
                dept_updatedby:accessuserid,
                dept_id: dept_id,
            };
            fetch(baseurladdress + `updatedepartment/` + dept_id, {
                method: "POST",
                headers: {
                    Accept: "application/form-data",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`,
                },
                body: JSON.stringify(data),
            })
                .then((res) => res.json())
                .then((result) => {
                    if (result["status"] === "updated") {    
                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 1200,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener('mouseenter', Swal.stopTimer)
                                toast.addEventListener('mouseleave', Swal.resumeTimer)
                            }
                        })
                        Toast.fire({
                            icon: 'success',
                            title: 'Edited Successfully'
                        })
                        navigate("/departmentlist");
                    } else {
                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 500,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener('mouseenter', Swal.stopTimer)
                                toast.addEventListener('mouseleave', Swal.resumeTimer)
                            }
                        })
                        Toast.fire({
                            icon: 'error',
                            title: 'Something went wrong'
                        })
                    }
                });
        };
    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <div class="content-wrap" style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                <div className="container-fluid">
                    <NavLink activeClassName="active-link" to={"/departmentlist"}>
                        <div style={{ display: "flex" }}>
                            <a class="float">
                                <i class="fa fa-arrow-left my-float" style={{ "marginTop": "21px" }}></i>
                            </a>
                        </div>
                    </NavLink>
                    <form onSubmit={handleSubmit}>
                        <div className='row'>
                            <div class="col-xl-12 col-xxl-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h4 class="card-title">EDIT DEPARTMENT DETAILS</h4>
                                    </div>
                                    <div class="card-body">
                                        <div class="basic-form">

                                            <div class="form-row">
                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Department Name</h6>
                                                    <input type="text"
                                                        class="form-control"
                                                        required
                                                        value={dept_name}
                                                        onChange={(e) => setdept_name(e.target.value)}
                                                    />
                                                </div>

                                                <div class="col-sm-3 mt-2 mt-sm-0">
                                                    <h6>Department Code</h6>
                                                    <input type="text"
                                                        class="form-control"
                                                        required
                                                        value={dept_code}
                                                        onChange={(e) => setdept_code(e.target.value)}
                                                    />
                                                </div>

                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Department Head Name</h6>
                                                    <input type="text"
                                                        class="form-control"
                                                        required
                                                        value={dept_headname}
                                                        onChange={(e) => setdept_headname(e.target.value)}
                                                    />
                                                </div>

                                                <div class="col-sm-1 mt-2 mt-sm-0">
                                                    <br />
                                                    <input type="checkbox" name="dept_status" className="selectsingle checku" checked={x} value={xy} id="exampleCheck1"
                                                        onClick={() => { setX(!x); }}
                                                        onChange={(event) => {
                                                            var checked = event.target.checked; if (checked == true) { setdept_status(1); }
                                                            else { setdept_status(0); }
                                                        }} /><label className="form__label textal offset-1" for="clienttype">
                                                        Status
                                                    </label>
                                                </div>

                                                <div class="col-sm-12 mt-2 mt-sm-0">
                                                    <h6>Description</h6>
                                                    <textarea class="form-control" style={{ height: "10em" }}
                                                        required
                                                        value={dept_description}
                                                        onChange={(e) => setdept_description(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 offset-6">
                                        <button type="submit" class="btn btn-primary mb-2" >Update</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    );
}

export default Editdepartment;